import { safeSelect } from '@sie/web-common-utils';
import Media from '../Media';
import Image from '../Image';
import MultiImage from '../MultiImage';
import AvatarIcon from '../AvatarIcon';

function isImageComponent(component) {
  var ComponentType = safeSelect(component, 'type');
  return ComponentType === Media || ComponentType === Image || ComponentType === MultiImage || ComponentType === AvatarIcon;
}

export default isImageComponent;